export const PHONE_NUMBER_TOS_HINT = 'By submitting your mobile number, you agree to receive important order information and updates.'
